import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const PrintIcon = ({ color = colors.black }) => {
    return (
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.551494 5.62376C0.85959 5.31566 1.27746 5.14258 1.71317 5.14258H14.2846C14.7203 5.14258 15.1382 5.31566 15.4463 5.62376C15.7544 5.93186 15.9275 6.34972 15.9275 6.78544V11.9283C15.9275 12.364 15.7544 12.7819 15.4463 13.09C15.1382 13.3981 14.7203 13.5711 14.2846 13.5711H11.9989C11.7227 13.5711 11.4989 13.3473 11.4989 13.0711C11.4989 12.795 11.7227 12.5711 11.9989 12.5711H14.2846C14.4551 12.5711 14.6186 12.5034 14.7392 12.3829C14.8597 12.2623 14.9275 12.0988 14.9275 11.9283V6.78544C14.9275 6.61494 14.8597 6.45143 14.7392 6.33087C14.6186 6.21031 14.4551 6.14258 14.2846 6.14258H1.71317C1.54267 6.14258 1.37916 6.21031 1.2586 6.33087C1.13804 6.45143 1.07031 6.61494 1.07031 6.78544V11.9283C1.07031 12.0988 1.13804 12.2623 1.2586 12.3829C1.37916 12.5034 1.54267 12.5711 1.71317 12.5711H3.99888C4.27503 12.5711 4.49888 12.795 4.49888 13.0711C4.49888 13.3473 4.27503 13.5711 3.99888 13.5711H1.71317C1.27746 13.5711 0.85959 13.3981 0.551494 13.09C0.243399 12.7819 0.0703125 12.364 0.0703125 11.9283V6.78544C0.0703125 6.34972 0.243399 5.93186 0.551494 5.62376Z"
                fill={color}
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5 11.3574C3.5 11.0813 3.72386 10.8574 4 10.8574H12C12.2761 10.8574 12.5 11.0813 12.5 11.3574V15.3574C12.5 15.6416 12.3871 15.9141 12.1862 16.115C11.9853 16.316 11.7127 16.4289 11.4286 16.4289H4.57143C4.28727 16.4289 4.01475 16.316 3.81381 16.115C3.61288 15.9141 3.5 15.6416 3.5 15.3574V11.3574ZM4.5 11.8574V15.3574C4.5 15.3764 4.50753 15.3945 4.52092 15.4079C4.53432 15.4213 4.55248 15.4289 4.57143 15.4289H11.4286C11.4475 15.4289 11.4657 15.4213 11.4791 15.4079C11.4925 15.3945 11.5 15.3764 11.5 15.3574V11.8574H4.5Z"
                fill={color}
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.81381 0.885103C4.01475 0.684171 4.28727 0.571289 4.57143 0.571289H11.4286C11.7127 0.571289 11.9853 0.684171 12.1862 0.885103C12.3871 1.08604 12.5 1.35856 12.5 1.64272V5.64272C12.5 5.91886 12.2761 6.14272 12 6.14272C11.7239 6.14272 11.5 5.91886 11.5 5.64272V1.64272C11.5 1.62377 11.4925 1.6056 11.4791 1.59221C11.4657 1.57881 11.4475 1.57129 11.4286 1.57129H4.57143C4.55248 1.57129 4.53432 1.57881 4.52092 1.59221C4.50753 1.60561 4.5 1.62377 4.5 1.64272V5.64272C4.5 5.91886 4.27614 6.14272 4 6.14272C3.72386 6.14272 3.5 5.91886 3.5 5.64272V1.64272C3.5 1.35856 3.61288 1.08603 3.81381 0.885103Z"
                fill={color}
            />

            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.9258 8.5C10.9258 8.22386 11.1496 8 11.4258 8H12.5686C12.8448 8 13.0686 8.22386 13.0686 8.5C13.0686 8.77614 12.8448 9 12.5686 9H11.4258C11.1496 9 10.9258 8.77614 10.9258 8.5Z"
                fill={color}
            />
        </svg>
    );
};

PrintIcon.propTypes = {
    color: PropTypes.string,
};

export default PrintIcon;
